import { render, staticRenderFns } from "./ConsultationRecord.vue?vue&type=template&id=16563654&scoped=true&"
import script from "./ConsultationRecord.vue?vue&type=script&lang=js&"
export * from "./ConsultationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16563654",
  null
  
)

export default component.exports